import Link from 'next/link';
import Button from '@/shared/components/flip-ui-kit/Button';
import BlockOutside from '@/shared/icons/flip-ui-kit/small/BlockOutside';
import { buildChainflipExplorerLink } from '@/shared/utils/chainflip';

export default function ViewEventButton({
  event,
}: {
  event: { indexInBlock: number; blockId: number } | null | undefined;
}) {
  const eventAddress = `${event?.blockId}-${event?.indexInBlock}`;

  const href = buildChainflipExplorerLink(eventAddress, 'events');

  return (
    <Link href={href} target={!href.startsWith('/') ? '_blank' : undefined}>
      <Button
        size="small"
        type="secondary-standard"
        className="max-w-fit gap-x-1 whitespace-nowrap"
      >
        <div>
          <BlockOutside className="text-cf-blue-2" />
        </div>
        <span className="text-12">View Event</span>
      </Button>
    </Link>
  );
}
